import initialState from "./initialState";

export const types = {
  reset: "reset",
  TOGGLE_INVITE_POPUP: "TOGGLE_INVITE_POPUP",
  TOGGLE_CREATE_DASHBOARD_POPUP: "TOGGLE_CREATE_DASHBOARD_POPUP",
  TOGGLE_DASHBOARD_SHARE_POPUP: "TOGGLE_DASHBOARD_SHARE_POPUP",
  TOGGLE_VERIFY_EMAIL_POPUP: "TOGGLE_VERIFY_EMAIL_POPUP",
  TOGGLE_WINDOW_SELECTION_POPUP: "TOGGLE_WINDOW_SELECTION_POPUP",
  TOGGLE_COMPUTED_PROPERTY_POPUP: "TOGGLE_COMPUTED_PROPERTY_POPUP",
  TOGGLE_CONSOLE_DETAILS_POPUP: "TOGGLE_CONSOLE_DETAILS_POPUP",
  TOGGLE_GRID_LOOKUP_POPUP: "TOGGLE_GRID_LOOKUP_POPUP",
};

export default {
  [types.reset]: state => {
    Object.keys(initialState()).forEach(key => {
      state[key] = initialState()[key];
    });
  },
  [types.TOGGLE_INVITE_POPUP]: state => {
    state.showInvitePopup = !state.showInvitePopup;
  },
  [types.TOGGLE_CREATE_DASHBOARD_POPUP]: state => {
    state.showCreateDashboardPopup = !state.showCreateDashboardPopup;
  },
  [types.TOGGLE_DASHBOARD_SHARE_POPUP]: state => {
    state.showDashboardSharePopup = !state.showDashboardSharePopup;
  },
  [types.TOGGLE_VERIFY_EMAIL_POPUP]: state => {
    state.showVerifyEmailPopup = !state.showVerifyEmailPopup;
  },
  [types.TOGGLE_WINDOW_SELECTION_POPUP]: state => {
    state.showWindowSelectionPopup = !state.showWindowSelectionPopup;
  },
  [types.TOGGLE_COMPUTED_PROPERTY_POPUP]: state => {
    state.showComputedPropertyCreationPopup = !state.showComputedPropertyCreationPopup;
  },
  [types.TOGGLE_CONSOLE_DETAILS_POPUP]: state => {
    state.showConsoleDetailsPopup = !state.showConsoleDetailsPopup;
  },
  [types.TOGGLE_GRID_LOOKUP_POPUP]: state => {
    state.showGridLookupPopup = !state.showGridLookupPopup;
  },
};
